<template lang="pug">
.meta-info
    .meta-info-item {{ $t(`${baseTranslationPath}.last_published`) }}: {{ getLastPublishedDate }}
    .meta-info-item.middle {{ $t(`${baseTranslationPath}.next_review_date`) }}: {{ getNextReviewDate }}
    .meta-info-item.end {{ $t(`${baseTranslationPath}.review_cycle`) }}: {{ getReviewFrequency }}
FileVersionList(:versions="getVersionHistory")
.upload-section
    .upload-info {{ $t(`${baseTranslationPath}.update_doc`, { name: getDocumentName}) }}
    FileUploader(
        :acl="getAcl",
        :fileList="fileList",
        @getFileList="getFileList"
    )
    .field-container.full-width.is-required.version-label-area
        label {{ $t(`${baseTranslationPath}.version`) }}
        aiq-input(v-model="versionLabel"
                    :max-length="250"
                    )
    .btn-area
        aiq-button(type="primary" @click="cancelUpdate") {{ $t('global.cancel') }}
        aiq-button(class="group-btn" :disabled="!canSubmit" @click="updateDocs") {{ $t('global.save') }}

</template>
<script>
import get from 'lodash/get';
import dayjs from '@/localPlugins/dayjs';
import FileVersionList from '@/components/FileUtil/FileVersionList.vue';
import FileUploader from '@/components/FileUtil/FileUploader.vue';
import { IMAGE_ACL_TYPES } from '@/constants';
import { getLatestVersion } from '../../common/util';

export default {
  name: 'HeaderNew',
  components: {
    FileVersionList,
    FileUploader,
  },
  emits: ['update-docs'],
  props: {
    smartControlRecord: {
      type: Object,
      default: () => {},
    },
    fileVersion: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.versionLabel = get(this.fileVersion, 'label', '');
  },
  data() {
    return {
      baseTranslationPath: 'settings_tab.admin_tab.smart_control.control_list_manage',
      fileList: [],
      versionLabel: '',
    };
  },
  computed: {
    getLastPublishedDate() {
      const completed_at = get(this.smartControlRecord, 'published_at');
      if (!completed_at) return 'N/A';
      return dayjs(completed_at).format('MMM D, YYYY h:mm A');
    },
    canSubmit() {
      return this.fileList.length > 0 && this.versionLabel.length > 0;
    },
    getAcl() {
      return get(this.fileVersion, 'file.payload.acl', IMAGE_ACL_TYPES.PRIVATE);
    },

    getDocumentName() {
      const name = get(this.smartControlRecord, 'name', '');
      return name;
    },

    getNextReviewDate() {
      const latest = getLatestVersion(this.getVersionHistory);
      const completed_at = get(latest, 'completed_at');
      if (!completed_at) return 'N/A';
      const freq_cycle = get(this.smartControlRecord, 'document.meta.smart_control.frequency_cycle', 1);
      return dayjs(completed_at).add(freq_cycle, 'days').format('YYYY-MM-DD');
    },
    getReviewFrequency() {
      const frequency = get(this.smartControlRecord, 'document.meta.smart_control.frequency_cycle');
      if (!frequency) return 'N/A';
      return `${frequency} ${frequency > 1 ? '(days)' : '(day)'}`;
    },
    getVersionHistory() {
      return get(this.smartControlRecord, 'versions', []);
    },
  },
  methods: {
    getFileList(files) {
      this.fileList = files;
    },
    updateDocs() {
      const payload = {
        label: this.versionLabel,
        file_id: get(this.fileList, '0.file_id', ''),

      };
      this.$emit('update-docs', payload);
      this.fileList = [];
    },
    cancelUpdate() {
      this.versionLabel = get(this.fileVersion, 'label', '');
      this.fileList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-section {
  padding-top: 20px;
  padding-bottom: 20px;
}
.upload-info {
  font-size: 12px;
  font-weight: 400;
  padding-bottom: 10px;
}

.version-label-area {
  padding-top: 20px;
  padding-left: 50px;
}
.btn-area {
  padding-top: 20px;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}
.meta-info {
  display: flex;
  gap: 10px;
  padding-bottom:20px;
}
.end {
  margin-left: auto;
}

.middle {
  margin-left: auto;
}

.meta-info-item {
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: #6a7682;
}
</style>